import * as React from "react";
import "styles/overlay.scss";

const Overlay: React.FC<{ showLoading?: boolean; isSessionLoading?: boolean }> =
  ({ children, showLoading, isSessionLoading }) => {
    return (
      <div className={`overlay ${isSessionLoading ? "overlay-session" : ""}`}>
        <div className="overlay-content">
          {showLoading && <i className="fas fa-spinner fa-spin fa-4x text-primary"></i>}
        </div>
        {children}
      </div>
    );
  };

export default Overlay;
